import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';

import CardViews from './views';


const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddingNote: false,
      isEditingNote: false
    };
  }

  onKeyDown = event => {
    const { keyCode, target } = event;
    const textContent = target.textContent;
    const { deleteHighlight } = this.props;

    if (keyCode === keys.enter || keyCode === keys.space) {
      event.preventDefault();

      if (textContent === 'Edit Note') {
        this.editNote(event);
      }

      if (textContent === 'Add Note') {
        this.addNote(event);
      }

      if (textContent === 'Delete') {
        deleteHighlight(event);
      }
    }
  };

  addNote = event => {
    const { isAddingNote, isEditingNote } = this.state;
    const highlightId = event.target.id.split('#')[1];

    if (isAddingNote) {
      return;
    }

    this.setState({
      isAddingNote: !isAddingNote,
      isEditingNote: !isEditingNote
    }, () => {
      const textarea = document.getElementById(`highlightId#${highlightId}`);
      textarea.focus();
    });
  };

  saveNote = highlightId => {
    const { isEditingNote } = this.state;

    this.setState({
      isEditingNote: !isEditingNote,
      isAddingNote: false
    }, () => {
      if (highlightId) {
        document.getElementById(`card#${highlightId}`).focus();
      }
    });
  };

  editNote = event => {
    const { isEditingNote } = this.state;
    const highlightId = event.target.id.split('#')[1];

    if (isEditingNote) {
      return;
    }

    this.setState({
      isEditingNote: !isEditingNote
    }, () => {
      const textarea = document.getElementById(`highlightId#${highlightId}`);
      textarea.focus();
      //set cursor at the end of text
      textarea.setSelectionRange(textarea.value.length,textarea.value.length);
    });
  };

  cancelEdit = highlightId => {
    const { isEditingNote } = this.state;

    this.setState({
      isEditingNote: !isEditingNote,
      isAddingNote: false
    }, () => {
      if (highlightId) {
        document.getElementById(`action#${highlightId}`).focus();
      }
    });
  };

  /**
   * Handles taking a user back to a section in his eBook by having clicked on a 'highlight'
   * from the 'Notebook' tab in the interface.
   */
  goToCfi = cfi => {
    window.vsViewer.goToCFI(cfi, function(result) {
    });

    this.props.toggle( 'E-book' );
  }

  render() {
    const { deleteHighlight, highlight } = this.props;
    let { isEditingNote, isAddingNote, noteText } = this.state;

    if (highlight.noteText && !noteText) {
      noteText = highlight.noteText;
    }

    const viewProps = {
      deleteHighlight,
      bodyStyle: {
        'backgroundColor': highlight.color
      },
      addNote: this.addNote,
      editNote: this.editNote,
      highlight,
      isAddingNote,
      isEditingNote,
      noteText,
      cancelEdit: this.cancelEdit,
      saveNote: this.saveNote,
      onKeyDown: this.onKeyDown,
      goToCfi: this.goToCfi
    };

    return <CardViews { ...viewProps } />;
  }
}

Card.defaultProps = {};

Card.propTypes = {
  deleteHighlight: func,
  highlight: object
};


export default connect(null, {})(Card);
